// Animacions d'entrada basades en CSS (fiables i independents de l'estat de visibilitat).
export const Reveal = ({ children, delay = 0, className = "" }) => (
  <div className={`ofc-reveal ${className}`} style={{ animationDelay: `${delay}s` }}>
    {children}
  </div>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <div className={`ofc-fade ${className}`} style={{ animationDelay: `${delay}s` }}>
    {children}
  </div>
);
